<template>
  <form
    class="new-auto-invoice"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline">
      <div class="column is-12">
        <VoucherDetails
          :is-loading="loading"
          :inline="true"
        />
      </div>

      <div class="column is-12">
        <Concepts :is-loading="loading" />
      </div>

      <div class="column is-12">
        <CfdisRelatedReplacement replacement-type="replacementInvoice" />
      </div>

      <div class="column is-12 action-buttons">
        <div class="field is-grouped">
          <p class="control">
            <button
              type="submit"
              class="button is-success"
              :class="{ 'is-loading': loading }"
              :disabled="loading"
            >
              Guardar
            </button>
          </p>
          <p class="control">
            <RouterLink
              class="button is-danger"
              :class="{ 'is-loading': loading }"
              :disabled="loading"
              :to="{ name: 'Home' }"
            >
              Cancelar
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'NewInvoice',
  components: {
    VoucherDetails: () => import(/* webpackChunkName: "invoice-voucher-details" */ '@/components/Admin/Invoices/NewInvoice/VoucherDetailsAutoInvoice.vue'),
    Concepts: () => import(/* webpackChunkName: "invoice-concepts" */ '@/components/Admin/Invoices/NewInvoice/Concepts.vue'),
    CfdisRelatedReplacement: () => import(/* webpackChunkName: "cfdis-related-replacement" */ '@/components/Admin/CFDI/CfdisRelatedReplacement.vue'),
  },
  data() {
    return {
      loading: false,
    };
  },
  beforeMount() {
    this.setInitialState();

    this.$store.commit(
      'users/setValues',
      { email: '', name: '' },
    );
  },
  methods: {
    ...mapActions({
      saveInvoice: 'invoice/auto',
    }),
    ...mapMutations({
      setInitialState: 'invoice/setInitialState',
    }),
    async onSubmit() {
      this.loading = true;
      try {
        await this.saveInvoice();
        this.setInitialState();
        this.$router.push({ name: 'AutoInvoiceList' });
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Guardado correctamente',
        });
        this.loading = false;
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: error.message,
        });
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.new-auto-invoice {
  padding: 1rem 2rem!important;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1088px) {
  .new-auto-invoice:not(.concepts) {
    width: calc(100vw - 265px);
  }
}
</style>
